import { api, apiAuth, baseURL } from "../http";

export const axiosAuthorized = apiAuth;
export { api, baseURL };
